import React from "react";

import Link from "next/link";
import {WEBSERVER} from "../services/globals";


export default function CatPath({ product }) {
  const path = [
    { name: "Home", url: "/" },
    ...product.collections.map(c => ({
      name: c.name,
      url: `/category/${c.slug}`
    }))
  ];

  return (
    <div>
      {path.map((p, i) => (
        <React.Fragment key={i}>
          <Link href={p.url}>{p.name}</Link>
          {i < path.length - 1 && " / "}
        </React.Fragment>
      ))}
    </div>
  );
}
